import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../lib/LangContext";
import { localizedPath } from "../lib/i18nRoutes";
import { SEO_TEXT } from "../lib/seoPages";

export default function NotFound() {
  const { lang } = useLang();
  const copy = (SEO_TEXT[lang] || SEO_TEXT.de).notFound;
  return (
    <main data-testid="not-found-page" className="relative min-h-[80vh] bg-[#050505] pt-40 pb-24 grain-overlay">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3">
          <span className="w-10 h-px bg-gold" />
          <span className="label-eyebrow">404</span>
        </div>
        <h1 data-testid="not-found-title" className="mt-8 font-heading text-white text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight">
          {copy.heading}
        </h1>
        <p className="mt-6 text-zinc-400 text-sm md:text-base max-w-xl">{copy.text}</p>
        <Link
          to={localizedPath(lang, "/")}
          data-testid="not-found-home-link"
          className="mt-10 inline-flex items-center gap-3 bg-gold text-black px-7 py-3.5 text-xs tracking-[0.25em] uppercase font-semibold hover:bg-[#f3e5ab] transition-colors"
        >
          <ArrowLeft size={14} /> {copy.cta}
        </Link>
      </div>
    </main>
  );
}
